/**
 * The one sentence a blocked helper adult sees when they cannot register an
 * athlete. Join-code denial, class sign-up, the sign-up picker, and the
 * program pages all use it. Gym staff cannot turn this permission on — only
 * the family's main guardian can, from Family Access (owner decision
 * 2026-09-04). Do not fork a second wording.
 */
export const CANNOT_REGISTER_ATHLETE_MESSAGE =
  "You do not have permission to register this athlete. Ask the family's main guardian for access in Family Access.";
